import React from "react";
import { reportClientError } from "@/components/SafeBoundary";

// Last line of defence: a crash anywhere shows a readable screen instead of a black page.
class AppErrorBoundary extends React.Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    console.error("App error:", error);
    reportClientError(error, `app ${info?.componentStack?.slice(0, 300) || ""}`);
  }

  componentDidMount() {
    window.addEventListener("error", this.onWindowError);
    window.addEventListener("unhandledrejection", this.onRejection);
  }

  componentWillUnmount() {
    window.removeEventListener("error", this.onWindowError);
    window.removeEventListener("unhandledrejection", this.onRejection);
  }

  onWindowError = (e) => reportClientError(e.error || e.message, "window.onerror");
  onRejection = (e) => reportClientError(e.reason, "unhandledrejection");

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div data-testid="app-error-screen" className="min-h-screen bg-black text-white flex items-center justify-center px-6">
        <div className="max-w-md text-center">
          <h1 className="font-impact text-4xl sm:text-5xl tracking-wide mb-4">
            OUPS, <span className="text-[#D90000]">UN PROBLÈME</span>
          </h1>
          <p className="text-white/70 text-sm mb-8">
            Si vous venez d'envoyer une demande, elle a bien été reçue. Rechargez la page pour continuer.
          </p>
          <button
            type="button"
            data-testid="app-error-reload-btn"
            onClick={() => window.location.reload()}
            className="inline-flex items-center justify-center bg-[#D90000] hover:bg-[#FF1A1A] text-white text-[12px] uppercase tracking-[0.25em] font-bold px-8 py-4 transition-colors"
          >
            Recharger la page
          </button>
        </div>
      </div>
    );
  }
}

export default AppErrorBoundary;
